import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

export default createUseStyles({
  button: {
    padding: '24px'
  },
  buttons: {
    width: '30%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  header: {
    padding: '24px'
  },
  container: {
    backgroundColor: WHITE,
    height: '100%',
    overflowY: 'auto',
    width: '100%'
  },
  responsive: {
    flexDirection: 'column',
    margin: '0 auto'
  }
})

export const mapContainerStyle = {
  width: '100%',
  height: '300px'
}

